module.exports = __webpack_public_path__ + "static/img/145.8a8eb6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/145.png
// module id = wxEn
// module chunks = 0